import { DEFAULT_PALETTE } from '../../core/palette';
import { SHATTER_PATTERN_OPTIONS } from '../../core/shatter';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const SHATTER_PARAMS = [
  {
    kind: 'int',
    key: 'fragments',
    label: 'Fragmente',
    min: 4,
    max: 1200,
    step: 1,
    scale: 'log',
    default: 90,
    bulkRange: [20, 300],
    group: 'Bruch',
  },
  {
    kind: 'enum',
    key: 'pattern',
    label: 'Bruchmuster',
    default: 'voronoi',
    group: 'Bruch',
    options: SHATTER_PATTERN_OPTIONS,
  },

  {
    kind: 'float',
    key: 'explosion',
    label: 'Explosionskraft',
    min: 0,
    max: 60,
    step: 0.5,
    default: 9,
    bulkRange: [0, 30],
    group: 'Simulation',
  },
  {
    kind: 'vec2',
    key: 'origin',
    label: 'Explosionszentrum',
    min: { x: -0.5, y: -0.5 },
    max: { x: 1.5, y: 1.5 },
    step: 0.005,
    default: { x: 0.5, y: 0.5 },
    square: false,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'gravity',
    label: 'Schwerkraft',
    min: -2,
    max: 3,
    step: 0.01,
    default: 0.9,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'restitution',
    label: 'Sprungkraft',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.32,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'friction',
    label: 'Reibung',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.35,
    group: 'Simulation',
  },
  {
    kind: 'float',
    key: 'spin',
    label: 'Rotationsjitter',
    min: 0,
    max: 1,
    step: 0.01,
    default: 0.3,
    group: 'Simulation',
  },
  {
    kind: 'int',
    key: 'steps',
    label: 'Standbild nach',
    min: 0,
    max: 900,
    step: 1,
    default: 90,
    unit: 'Schr.',
    bulkRange: [10, 300],
    group: 'Simulation',
    tooltip: '0 zeigt den Moment vor dem Bruch.',
  },
  {
    kind: 'bool',
    key: 'walls',
    label: 'Boden und Wände',
    default: true,
    group: 'Simulation',
  },

  {
    kind: 'enum',
    key: 'style',
    label: 'Stil',
    default: 'fill',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'fill', label: 'Füllung' },
      { value: 'stroke', label: 'Kontur' },
      { value: 'both', label: 'Beides' },
    ],
  },
  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Strichstärke',
    min: 0.2,
    max: 8,
    step: 0.1,
    default: 1,
    unit: 'px',
    group: 'Darstellung',
    showIf: (v) => v.style !== 'fill',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.05,
    max: 1,
    step: 0.01,
    default: 1,
    group: 'Darstellung',
  },

  {
    kind: 'enum',
    key: 'colorMode',
    label: 'Farbmodus',
    default: 'speed',
    group: 'Farbe',
    options: [
      { value: 'solid', label: 'Einfarbig' },
      { value: 'speed', label: 'Nach Tempo' },
      { value: 'height', label: 'Nach Höhe' },
      { value: 'random', label: 'Zufällig' },
    ],
  },
  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'ember' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type ShatterValues = SchemaValues<typeof SHATTER_PARAMS>;
